export const sortBy: <T>(
  array: T[],
  key: string,
  desc?: boolean | undefined
) => T[] = <T>(array: T[], key: string, desc?: boolean) =>
  [...array].sort((a: T, b: T) => (desc ? b[key] - a[key] : a[key] - b[key]));
